import is from '@sindresorhus/is';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { LearningOpportunityOptions } from '~/shared/data-contract/learning-opportunities';
import { learningOpportunityOptionsSchema } from '~/shared/data-contract/learning-opportunities';
import type { Pathname } from '~/shared/http-fetcher/http-fetcher';

import { learningOpportunityKeys } from './query-keys';

export const useLearningOpportunityOptionsQuery = (
    learningOpportunityId: string,
): UseQueryResult<LearningOpportunityOptions> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const pathname: Pathname = `/learning-opportunities/${learningOpportunityId}/options`;

    return useQuery({
        enabled: is.nonEmptyString(learningOpportunityId),
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(learningOpportunityOptionsSchema, {
                pathname,
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: learningOpportunityKeys.optionsForId(learningOpportunityId),
        throwOnError: false,
    });
};
